import { apiClient } from "../client";

export async function backendLogin(): Promise<void> {
  await apiClient.post("users/me/sync");
}
